import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {SearchContainer} from "../../../core/definitions/search-container";
import {SearchExecutorService} from "../../search-executor.service";
import { SearchResultViewType } from 'src/app/core/definitions/search-result-view-type.enum';
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationModalComponent} from "../../../shared/confirmation-modal/confirmation-modal.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-search-view-pagination',
    imports: [
      MatPaginator
    ],
    templateUrl: './search-view-pagination.component.html',
    styleUrl: './search-view-pagination.component.scss'
})
export class SearchViewPaginationComponent implements OnInit {
  // Injections
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);
  private readonly translate: TranslateService = inject(TranslateService);

  @Input() searchContainer: SearchContainer;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  viewNames = SearchResultViewType;

  ngOnInit() {
    if(this.searchContainer) {
      this.searchContainer.virtualScrollEnabled = false;
      this.searchContainer.searchPage = this.searchContainer.searchPage ?? 1;
      this.searchContainer.rows = typeof this.searchContainer.rows === 'number' ? this.searchContainer.rows  : DEFAULT_SEARCH_ROWS;
      this.searchExecutorService.runSearch(this.searchContainer, true).then();
    }
  }

  paginationChange(event: PageEvent) {
    let hideWarning = false;

    if (localStorage.getItem('primus.hidePaginationWarning')) {
      hideWarning = localStorage.getItem('primus.hidePaginationWarning') === 'true';
    }

    if (event.pageSize >= 500 && !hideWarning) {
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: {
          title: this.translate.instant('TRANS__PAGINATION__WARNING_TITLE', { count: event.pageSize }),
          content: this.translate.instant('TRANS__PAGINATION__WARNING_CONTENT', { count: event.pageSize }),
          confirmButtonText: 'TRANS__PAGINATION__WARNING_CONFIRM',
          cancelButtonText: 'TRANS__PAGINATION__WARNING_CANCEL',
        }
      });

      dialogRef.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.setPagingData(event);
        }
        else {
          // Here to reset pagesize display as this changes on click regardless of confirmation
          this.paginator.pageSize = this.searchContainer.rows;
        }
      });
    }
    else {
      this.setPagingData(event);
    }
  }

  setPagingData(event: PageEvent) {
    if (event.pageIndex + 1 !== this.searchContainer.searchPage) {
      this.searchContainer.searchPage = event.pageIndex + 1;
    }

    if (event.pageSize !== this.searchContainer.rows) {
      this.searchContainer.searchPage = 1;
      this.searchContainer.rows = event.pageSize;
      this.searchContainer.selections.allSelectedForPage = {};
    }
    this.searchExecutorService.runSearch(this.searchContainer, true, true).then(() => {
      setTimeout(() => {
        this.searchContainer.selections.allSelected = !!this.searchContainer.selections.allSelectedForPage[
          this.searchContainer.searchPage]
      }, 500);
    });
  }
}

const DEFAULT_SEARCH_ROWS = 50;
